import { Button } from '@jobcost-monorepo/ui';
import { useController, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

type Props = {
  name: string;
  label: string;
};

const TriState: React.FC<Props> = ({ name, label }) => {
  const { control } = useFormContext();
  const {
    field: { value, onChange },
  } = useController({ control, name });

  const { t } = useTranslation();

  return (
    <div className="w-full mx-4">
      <div className="w-full flex flex-col">
        <label
          htmlFor={name}
          className="block text-sm font-medium text-gray-700"
        >
          {label}
        </label>
        <div className="mt-4 flex space-x-4">
          <Button
            onClick={() => {
              onChange(undefined);
            }}
            value={value}
          >
            {t('filters.all')}
          </Button>
          <Button
            className={`${value === true && 'bg-purple50'}`}
            onClick={() => {
              onChange(true);
            }}
            value={value}
          >
            {t('filters.yes')}
          </Button>
          <Button
            className={`${value === false && 'bg-purple50'}`}
            onClick={() => {
              onChange(false);
            }}
            value={value}
          >
            {t('filters.no')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TriState;
